export enum STORE_ID {
  AUTH = 'auth',
  BRIGHTNESS = 'brightness',
  CUSTOM_CHOICE = 'customChoice',
  MENU = 'menu',
  ORDER = 'order',
  ORDER_HISTORY = 'orderHistory',
  PAYMENT = 'payment',
  STRIPE_PAYMENT_SHEET = 'stripePaymentSheet',
  PERMANENT = 'permanent',
  POLLING = 'polling',
  PRODUCT = 'product',
  PROMOTIONS = 'promotions',
  RELISH = 'relish',
  RESTAURANT = 'restaurant',
  TRACK = 'track',
  USER = 'user',
  USER_DATA = 'userData',
  NAVIGATION_MENU = 'navigationMenu',
  UI = 'ui',
  NAVIGATION = 'navigation',
  APP_STATUS = 'appStatus'
}

export type StoreId =
  | 'auth'
  | 'brightness'
  | 'customChoice'
  | 'menu'
  | 'order'
  | 'orderHistory'
  | 'payment'
  | 'stripePaymentSheet'
  | 'permanent'
  | 'polling'
  | 'product'
  | 'promotions'
  | 'relish'
  | 'restaurant'
  | 'track'
  | 'user'
  | 'userData'
  | 'navigationMenu'
  | 'ui'
  | 'navigation'
  | 'appStatus'
